import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import * as fromUser from '../reducers/user.reducer';

export const getUserState = createSelector(
  fromFeature.selectAuthState,
  (state: fromFeature.AuthState) => state.user
);

export const getUser = createSelector(
  getUserState,
  fromUser.getUser
);

export const getUserLoaded = createSelector(
  getUserState,
  fromUser.getUserLoaded
);

export const getUserLoading = createSelector(
  getUserState,
  fromUser.getUserLoading
);
